import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddPortPayload {
	hardwareResourceId?: number; // Required for physical ports
	portName: string;
	portNumber: string;
	portType: string;
	portStatus: string;
	l2Description: string;
	l3Description: string;
	id?: number;
	portId?: string;
	// New fields
	subscriptionId?: string;
	tenantId?: number | null;
	isDraft?: number; // 0 = Draft, 1 = Active
	isVirtualPort?: boolean; // false = Physical, true = Virtual
	// Provider fields (for virtual ports)
	provider?: string;
	providerAccount?: string; // "1" for Telecom, "2" for CTX
	providerId?: string;
	// P2P Addressing
	mask?: string;
	peerIp?: string;
	gateway?: string;
	network?: string;
	// Tags and Terms
	tags?: string[];
	terms?: string;
	// Crossconnect Information (for virtual ports)
	crossconnectType?: string;
	crossconnectSpeed?: string;
	crossconnectId?: string;
}

//GET v1/resource-manager/tenants
//This function returns all tenants
export function getTenants(token: string){
	return axios.get(`${API_URL}/v1/resource-manager/tenants`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET v1/port/:hardwareId/listPorts
export function getPortsByHardwareId(token: string, hardwareId: string) {
	return axios.get(`${API_URL}/v1/port/${hardwareId}/listports`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
//GET port allocation by hardware
export function getListPortsByHardwareId(token: string, hardwareId: number) {
	return axios.get(`${API_URL}/v1/resource-manager/port-allocations/by-hardware/${hardwareId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//GET v1/port/id
export function getPortsById(token: string, id: number) {
	return axios.get(`${API_URL}/v1/port/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//GET v1/port 
//This function returns all ports by default
export function getAllPorts(token: string){
	return axios.get(`${API_URL}/v1/port`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET v1/resource-manager/ke-ports
//This function returns the KE ports list
export function getKEPorts(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-ports`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//GET v1/resource-manager/ke-ports/:id
//This function returns a specific KE port by ID
export function getKEPortById(token: string, id: number) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-ports/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//GET v1/resource-manager/hardware/filter
export function getHardwareListByDataCenter(
	token: string,
	datacenterId: string
) {
	const params = new URLSearchParams({
		typeHardwareId: "1",
		subtypeHardwareId: "1",
		datacenterId: datacenterId,
	});

	return axios.get(
		`${API_URL}/v1/resource-manager/hardware/filter?${params.toString()}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);
}

//POST v1/port/add
export function addPort(token: string, payload: AddPortPayload) {
	return axios.post(`${API_URL}/v1/port/add`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/port/:id
export function updatePort(token: string, id: number, payload: AddPortPayload) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/port/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/port/:id
export function deletePort(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/port/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
